import React, { FC } from 'react';
import { ButtonAsWrapper, FlexCol, FlexRow, H2Text, H3Text } from '@minecraft.atoms';
import Icon from '@minecraft.icon';
import { DiscountTypeEnum } from '@minecraft.graphql-operations';
import { useTranslation } from '@blocs.i18n';
import { SelectPlanSmProps } from './types';
import { PlanType } from '../usePlans';
import { CheckoutHead } from './CheckoutHead';
import { PlanFeatureCardList } from './PlanFeatureCard';
import { InfiniteBrandSroller } from './InfiniteBrandSroller';

const PlanCard: FC<{ plan: PlanType; selectedPlan: PlanType; setSelectedPlan: (plan: PlanType) => void }> = ({
  plan,
  selectedPlan,
  setSelectedPlan,
}) => {
  return (
    <ButtonAsWrapper aria-label={plan.title} onClick={() => setSelectedPlan(plan)}>
      <FlexCol
        borderSize={0.1}
        borderColor="default"
        borderPlacement="all"
        borderRadius="md"
        minHeight={6}
        minWidth={10}
        justifyContent="center"
        alignItems="center"
        gap="1"
        bgColor={selectedPlan.name === plan.name ? `${plan.temperature}PaywallDarkBg` : 'transparent'}
      >
        {plan.icon && <Icon name={plan.icon} themeColor="active" />}
        <H2Text>{plan.title}</H2Text>
      </FlexCol>
    </ButtonAsWrapper>
  );
};

export const SelectPlanSm: FC<SelectPlanSmProps> = ({
  plans = [],
  setSelectedPlan,
  isAnnual,
  isToggleLocked,
  setIsAnnual,
  selectedPlan,
  discountType,
  countryCode,
  currencyCode,
  loading,
}) => {
  const { t } = useTranslation();
  if (plans.length <= 1 || loading) return null;
  const isReppedRegDiscount = discountType === DiscountTypeEnum.ReppedRegistrationDiscount;

  if (isReppedRegDiscount) {
    return (
      <FlexCol gap="6">
        <H3Text color="default">{t('common:paywall.paymentAndPlanDetails.title')}</H3Text>
        <CheckoutHead
          isAnnual={isAnnual}
          setIsAnnual={setIsAnnual}
          isToggleLocked={isToggleLocked}
          plans={plans}
          countryCode={countryCode}
          currencyCode={currencyCode}
        />
        <PlanFeatureCardList
          plans={plans}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
          isReppedRegDiscount={isReppedRegDiscount}
          countryCode={countryCode}
          disableTrial
        />
        <InfiniteBrandSroller />
      </FlexCol>
    );
  }

  return (
    <FlexRow alignContent="center" justifyContent="center" gap="2" w="full">
      {plans.map((p) => (
        <PlanCard key={p.name} plan={p} selectedPlan={selectedPlan} setSelectedPlan={setSelectedPlan} />
      ))}
    </FlexRow>
  );
};
